import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonObject } from "typedjson";
import { PitRequestCriteriaFilter } from "./pit-request-criteria-filter";
import { PitRequestCriteriaSort } from "./pit-request-criteria-sort";
/** Набор критериев для выборки */
let PitRequestHiddenCriteria = class PitRequestHiddenCriteria {
    constructor(fields) {
        /** Массив условий фильтрации выборки */
        this.filters = [];
        this.sorts = [];
        if (fields)
            Object.assign(this, fields);
    }
};
tslib_1.__decorate([
    jsonArrayMember(PitRequestCriteriaFilter, { emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitRequestHiddenCriteria.prototype, "filters", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitRequestCriteriaSort, { emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitRequestHiddenCriteria.prototype, "sorts", void 0);
PitRequestHiddenCriteria = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitRequestHiddenCriteria);
export { PitRequestHiddenCriteria };
